/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Agent_Policy_Destructive_Confirm_Created_ByInputs */



/**
* | output |
* | --- |
* | "Created by {name}" |
*
* @param {Agent_Policy_Destructive_Confirm_Created_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_created_by = /** @type {((inputs: Agent_Policy_Destructive_Confirm_Created_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_Created_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Erstellt von ${i?.name}`)
	return /** @type {LocalizedString} */ (`Created by ${i?.name}`)
});